import { useEffect, useRef } from 'react';
import { appHandler } from '@blaze-cms/core-ui';
import { useCheckoutAdditionalDetails } from '@blaze-cms/ecommerce-context';
import { CHECKOUT_DETAILS_KEY, PURCHASE_EVENT } from '../constants';

/**
 * Sends the captured set with every checkout request, under
 * additionalDetails.campaign, and clears it once the order has been placed.
 *
 * The checkout can be submitted more than once (a 3DS step re-submits it), so
 * the details callback returns the same values each time and has no side
 * effects; clearing waits for the purchase event instead.
 */
const useCampaignCheckout = ({ params, hasAttribution, expiresAt, clear }) => {
  // Checked at submit time too, so an expired set is never sent even if the
  // provider has not yet dropped it.
  useCheckoutAdditionalDetails(() =>
    hasAttribution && expiresAt > Date.now() ? { [CHECKOUT_DETAILS_KEY]: { ...params } } : undefined
  );

  const clearRef = useRef(clear);
  useEffect(() => {
    clearRef.current = clear;
  });

  useEffect(() => {
    const app = appHandler.getApp();
    if (!app) return undefined;

    const onPurchase = () => clearRef.current();
    app.events.on(PURCHASE_EVENT, onPurchase);

    return () => {
      app.events.off(PURCHASE_EVENT, onPurchase);
    };
  }, []);
};

export default useCampaignCheckout;
